let adminJwtKey = null;
if(process.env.REACT_APP_ADMIN_JWT_KEY){
    adminJwtKey = process.env.REACT_APP_ADMIN_JWT_KEY;
}

const ADMIN_JWT_KEY = adminJwtKey;

export { ADMIN_JWT_KEY };